//TODO: DELETE UPON INTEGRATION
export const SAMPLE_PROGRAMS = [
	{
		title: 'Travel Program',
		description:
			"Simplify the process for employees to expense rides directly through the Xpress app. Additionally, gain valuable insights into your team's transportation expenditure.",
		active: true,
		image: '/images/svg/blue-car.svg',
	},
	{
		title: 'Business Travel',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
		active: true,
		image: '/images/svg/blue-car.svg',
	},
	{
		image: '/images/svg/concierge.svg',
		title: 'Concierge',
		description:
			'Simplify Transportation for Everyone: Request Rides for Employees, Customers, and Guests - No App Needed',
		active: false,
	},
];
